export default "__VITE_ASSET__82846252__"